/*==================================================
//search セレクトボックスを選択したら選択したものを表示
// 職種情報、製品・環境
==================================================*/
$(function () {
    if($('.search-form, .search').length) {
      console.log('フォームあり');
      
        $('.field-checkbox').on('click', function () {
            if ($(this).find('.field-checkbox-input').prop("checked") == true) {
                let result = $(this).parent().parent('.form-content').children('.select-result');
                let selectCkeckBox = $(this).find('span').text();
                let text = $(this).parent().parent('.form-content').children('.select-result').html();
                let regExp = new RegExp('<span class="no-select">指定しない</span>', "g");
                // textから「指定しない」を絞りこむ
                let selected = text.replace(regExp, "");
                $(this).parent().parent('.form-content').children('.select-result').html(selected);
                result.children('.selected').append("<span>" + selectCkeckBox + "</span>");

            } else {
                let selectedTag = $(this).parent().parent('.form-content').children('.select-result').children('.selected');
                let selectedProduct = selectedTag.html();
                // チェックした項目の結果
                let selectCkeckBox = $(this).find('.checkbox-parts').text();
                // チェックした項目のラベルテキストを取り出す。
                let removeProduct = "<span>" + selectCkeckBox + "</span>";
                // チェックした項目のラベルテキストにspanタグをつける
                let regExp = new RegExp(removeProduct, "g");
                // spanタグをつけたものを結果から絞り込む
                let selected = selectedProduct.replace(regExp, "");
                // 絞り込んだものを結果から削除する
                selectedTag.html(selected);
                // 取り出して残ったものをselectedクラスの要素の中に戻す。
            };
        });
        // 選択が1つもない時、「指定しない」を戻す。
        $('.field-checkbox').on('click', function () {
            if ($(this).find('.field-checkbox-input').prop("checked") == false) {
                let selectedTag = $(this).parent().parent('.form-content').children('.select-result').children('.selected');
                let result = $(this).parent().parent('.form-content').children('.select-result');
                if (selectedTag.find('span').length == 0) {
                    result.append('<span class="no-select">指定しない</span>');
                }
            };
        });

    }
});

$(function () {
    $('.favorite-btn, .message-btn, .event-btn, .feature-btn').on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
    });
    $('.favorite-btn').on('click', function (e) {
        if ($(this).hasClass('push')) {
            $(this).removeClass('push');
            $(this).find('svg').attr('data-prefix', 'far');
        } else {
            $(this).find('svg').attr('data-prefix', 'fas');
            $(this).addClass('push');
        };
    });
})
